import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { alpha } from "@mui/material/styles";

/**
 * Generic metric card with subtle tinted background.
 * Props:
 * - color: one of 'success' | 'error' | 'info' | 'warning' | 'primary' | 'secondary'
 * - title: string (e.g., "Total Deposits")
 * - value: string (e.g., "$48,500")
 * - caption: string (e.g., "(3 accounts)")
 * - icon: ReactNode (optional)
 */
export default function SummaryMetricCard(props) {
  const { color = "info", title, value, caption = "", icon = null } = props;
  return (
    <Card
      sx={(theme) => {
        const c = theme.palette[color] || theme.palette.info;
        return {
          borderRadius: 2,
          border: "1px solid",
          borderColor: alpha(c.main, 0.35),
          boxShadow: 0,
          bgcolor: alpha(c.main, 0.08),
        };
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {icon}
          <Typography variant="subtitle2" color="text.secondary">
            {title}
          </Typography>
        </Box>
        <Typography variant="h5" fontWeight="bold">{value}</Typography>
        {caption ? (
          <Typography variant="body2" color="text.secondary">
            {caption}
          </Typography>
        ) : null}
      </CardContent>
    </Card>
  );
}
